import { FC } from 'react';
import { Box, Checkbox, Stack, Typography } from '@mui/material';
import { DashboardAccessItemStatus } from './types';

interface DashboardAccessItemProps {
  id: string;
  name: string;
  status: DashboardAccessItemStatus;
  icon: string;
  checked: boolean;
  disabled?: boolean;
  showCheckbox?: boolean;
  onCheckChange: (id: string, checked: boolean) => void;
}

const iconMap: Record<string, string> = {
  BENCHMARKS: 'tour_dark.svg',
  UNDERWRITING: 'underwriting_dark.svg',
  FUNDING_ELIGIBILITY: 'invoice_dark.svg',
  'Financial Projections': 'analytics_dark.svg',
};

const StatusColorMap = {
  GRANTED: '#28A745',
  PENDING: '#FFA726',
  DISABLED: '#D3D3D3',
  FAILED: '#FF0000',
};

const formatDashboardName = (name: string) =>
  name
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

const DashboardAccessItem: FC<DashboardAccessItemProps> = ({
  id,
  name,
  status,
  icon,
  checked,
  disabled = false,
  showCheckbox = true,
  onCheckChange,
}) => {
  return (
    <Stack direction={'row'} gap={'0.5rem'} alignItems={'center'}>
      {showCheckbox && (
        <Checkbox
          disableFocusRipple
          disableRipple
          disableTouchRipple
          sx={{ p: 0 }}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onCheckChange(id, e.target.checked)}
        />
      )}
      <Stack
        sx={{
          border: '1px solid #E8EAEB',
          borderRadius: '0.5rem',
          width: '100%',
          padding: '0.5rem 1rem',
        }}
        direction={'row'}
        gap={'0.5rem'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Stack direction={'row'} gap={'0.5rem'} alignItems={'center'}>
          <Box
            sx={{
              width: '10px',
              height: '10px',
              borderRadius: '2px',
              backgroundColor: StatusColorMap[status] || '#C2C2C2',
            }}
          ></Box>
          <Typography fontSize={'0.75rem'} fontWeight={700} lineHeight={'1rem'} color={'#162936'}>
            {formatDashboardName(name)}
          </Typography>
        </Stack>
        <Box>
          <img
            src={iconMap[icon] ? require(`../../../../../../assets/icons/${iconMap[icon]}`) : ''}
            alt=""
            style={{ width: '1.5rem' }}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default DashboardAccessItem;
